import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { BusinessAreaEditComponent } from '@fi-app/business-area/business-area-edit/business-area-edit.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { BusinessAreaService } from '@fi-app/business-area/business-area.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiBusinessAreaEditState: Ng2StateDeclaration = {
    name: FiStateNames.BusinessArea.Edit,
    url: '/:Id/Edit',
    views: {
        '@': {
            component: BusinessAreaEditComponent,
        },
    },
    resolve: {
        businessArea: [BusinessAreaService, FiStateService, Transition, FiBusinessAreaEditStateResolve_businessArea],
        pageTitle: [PageTitleService, 'businessArea', FiBusinessAreaEditStateResolve_pageTitle],
    },
};

export function FiBusinessAreaEditStateResolve_businessArea(
    businessAreaService: BusinessAreaService,
    fiStateService: FiStateService,
    tr: Transition,
) {
    return businessAreaService.GetBusinessArea(fiStateService.getParams(tr).Id);
}

export function FiBusinessAreaEditStateResolve_pageTitle(ccmPageTitle: PageTitleService, businessArea) {
    return ccmPageTitle.setTitleByItem(businessArea);
}
